import { render, staticRenderFns } from "./format-wx-time.vue?vue&type=template&id=6f617e46&scoped=true&"
import script from "./format-wx-time.vue?vue&type=script&lang=js&"
export * from "./format-wx-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f617e46",
  null
  
)

export default component.exports